export default "__VITE_PUBLIC_ASSET__c8a8e4c3__"